<template>
  <div class="single-share-link-button">
    <wt-button
      v-if="isCopied"
      type="transparent"
      icon="wticon-link2"
      class="-custom"
      :disabled="true"
      :text="'fullPreview.COPIED' | culture"
    />
    <wt-button
      v-else-if="showGeneratedLink"
      type="transparent"
      icon="wticon-share3"
      class="-custom"
      :text="'fullPreview.SHARE_YOUR_STORY' | culture"
      @click="onCopyLink"
    />
    <wt-button
      v-else-if="!showGeneratedLink"
      type="transparent"
      class="-custom"
      :disabled="true"
      :processing="true"
      :text="'fullPreview.COPY_GENERATING' | culture"
      @click="onCopyLink"
    />
  </div>
</template>

<script>
export default {
  name: 'single-share-link-button',

  props: {
    showGeneratedLink: { type: Boolean, required: true },
    isCopied: { type: Boolean, required: true },
  },

  methods: {
    onCopyLink() {
      this.$emit('on-copy-link');
    },
  },
};
</script>

<style scoped lang="scss">
.single-share-link-button {
  .wt-button {
    font-size: 14px;
  }
}
</style>
